import EDITOR_ICON from 'editor/icon-editor.svg'
import UPLOAD_ICON from 'editor/icon-upload.svg'
import CART_ICON from 'editor/icon-cart.svg'
import WHATSAPP_ICON from 'editor/icon-whatsapp-default.svg'
import DESIGNER_ICON from 'editor/icon-designer.svg'


export interface DESIGN_OPTION_ITEMS {
  icon: string,
  subIcon?: string,
  title: string,
  subTitle?: string,
  state: string,
  description: string[]
}

export const MAX_SLIDER_IMAGE_COUNT = {
  MOBILE_WIDTH: 5,
  DESKTOP_WIDTH: 7
}

export const OPTION_ERROR_MESSAGES: { [key: string]: string } = {
  CART_ITEM_VALIDATE: 'Cart item validation error. Please try again',
  FILE_SIZE_VALIDATE: 'Upload Failed: Incompatible file size. Please upload file not exceeding 100 MB',
  FILE_EXTENSION_VALIDATE: 'Upload Failed: Incompatible file format. Please upload in  ai, png, pdf, jpeg, jpg, psd or zip  format'
}

export const OPTION_ITEM: {[key:string]: string} = {
  DESIGN_TOOL: 'design_tool',
  DESIGN_FILE: 'design_file',
  DESIGN_SERVICE: 'design_service',
  ADD_TO_CART: 'add_to_cart'
}

export const DESIGN_OPTIONS: DESIGN_OPTION_ITEMS[] = [
  {
    icon: EDITOR_ICON,
    title: 'Use Design Tool',
    subTitle: 'Recommended',
    description: [
      'Our Design Tool could help you to place, edit, and preview your design',
      'Ideal CUSTA design experience'
    ],
    state: OPTION_ITEM.DESIGN_TOOL
  },
  {
    icon: UPLOAD_ICON,
    title: 'Upload Design',
    description: [
      'Recommended if you have your own design file',
      'Accepted format: ai, png, pdf, jpeg, jpg, psd, zip with max size of 100 MB'
    ],
    state: OPTION_ITEM.DESIGN_FILE
  },
  {
    icon: CART_ICON,
    title: 'Add to Cart',
    description: [
      'Recommended If your design is not yet ready',
      'Go to cart page first and upload the design later'
    ],
    state: OPTION_ITEM.ADD_TO_CART
  },
  {
    icon: DESIGNER_ICON,
    subIcon: WHATSAPP_ICON,
    title: 'Ask Our Designer',
    description: [
      'Our dedicated designer could help you to design your product',
      'Free design services for order above RM 500'  // TODO: confirm with edward on changing this to SG
    ],
    state: OPTION_ITEM.DESIGN_SERVICE
  }
]

export const SUPPLIER_RESOURCE_BY_PRODUCT: { [key: string] : string} = {
  '545': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/545.zip',
  '546': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/546.zip',
  '547': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/547.zip',
  '548': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/548.zip',
  '549': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/549.zip',
  '550': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/550.zip',
  '551': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/551.zip',
  '2058': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/2058.zip'
}
export const WEARABLE_PRODUCTS_ID: number[] = [
  96,97,98,99, 100, 101, 102, 103
]
export const GIFTEE_PRODUCTS_ID: number[] = [ ]
export const QUICK_DELIVERY_PRODUCTS: { [key: string] : string} = {
  '1476': '93',
  '1477': '80',
  '1478': '81',
  '1479': '83',
  '1480': '173',
  '1481': '197',
  '1485': '89',
  '1486': '90',
  '1487': '82',
  '1488': '191',
  '1489': '196',
  '1490': '198',
  '1593': '175',
  '1594': '560',
  '1946': '72',
  '1947': '74',
  '2030': '216'
}
export const ENDPOINT: { [key: string] : string}  = {
  CART_ITEMS: '/cart_items/'
}
export enum SERVER_ERRORS {
  NO_TRIAL_SUPPORT = 'GP001'
}

export const SUBMISSION_FILE_EXTENSIONS = ['ai','png','pdf','jpeg','jpg','psd','zip']

export const ENDPOINTS : { [key: string] : string} = {
  CART_ITEMS: '/cart_items/',
  PRODUCTS: '/api/v1/products/%id',
  ESTIMATE_ITEMS: '/estimate_items',
  ESTIMATE_ITEM: '/estimate_items/%s',
  ESTIMATE: '/api/v1/printable_skus/%id/estimate',
  PRICE_TABLE: '/api/v1/printable_skus/%id/price_table',
  DESIGN_SUBMISSION: '/api/v1/submissions/user_upload_files'
}
